const styles = {

  Text_input: {
    width: "100%",
  },

}

const chromePickerStyles = {
  default: {
    picker: { 
      backgroundColor: "#383838",
    },
  },
}

export {styles, chromePickerStyles}